import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    height: 'calc(100% - 157px)'
  },
  grid: {
    minWidth: 400,
    height: 'calc(100% - 30px)',
    margin: 15,
    marginRight: 0
  },
  dataGrid: {
    width: '100%',
    height: '100%'
  },
  Icon: {
    cursor: 'pointer',
  },
  actionButtonIcon: {
    cursor: 'pointer',
    fontSize: '18px',
    margin: '0 3px',
    color: '#337ab7'
  },
  anchor: {
    display: 'inline-flex'
  },
  disabledIcon: {
    color: 'gray',
    pointerEvents: 'none'
  }
});
